/**
 * Formatacao ABNT e geracao de PDF (via janela de impressao).
 *
 * As regras abaixo seguem a NBR 14724/6024 para trabalhos academicos:
 * papel A4, margens 3 cm (superior/esquerda) e 2 cm (inferior/direita),
 * fonte 12 pt, entrelinha 1,5 e recuo de primeira linha de 1,25 cm.
 * Citacoes longas: 10 pt, entrelinha simples e recuo de 4 cm.
 */

export const ABNT_PAGE_CSS = `
  @page {
    size: A4;
    margin: 3cm 2cm 2cm 3cm;
  }

  * { box-sizing: border-box; }

  body {
    font-family: 'Times New Roman', 'Liberation Serif', Times, serif;
    font-size: 12pt;
    line-height: 1.5;
    color: #000;
    background: #fff;
    margin: 0;
    text-align: justify;
  }

  h1, h2, h3, h4, h5, h6 {
    font-size: 12pt;
    font-weight: 700;
    text-align: left;
    text-indent: 0;
    margin: 1.2em 0 0.6em;
    line-height: 1.5;
  }

  p {
    text-indent: 1.25cm;
    margin: 0 0 0.4em;
    line-height: 1.5;
  }

  blockquote {
    font-size: 10pt;
    line-height: 1;
    margin: 1em 0 1em 4cm;
    text-indent: 0;
  }

  ul, ol { margin: 0 0 0.6em 1.25cm; padding: 0; }
  li { text-indent: 0; margin-bottom: 0.2em; }

  hr { border: none; border-top: 1px solid #000; margin: 1.2em 0; }

  a { color: #000; text-decoration: none; }

  table { width: 100%; border-collapse: collapse; font-size: 11pt; }
  th, td { border: 1px solid #000; padding: 6px 8px; text-align: left; }
  th { font-weight: 700; }

  .doc-title {
    font-size: 12pt;
    font-weight: 700;
    text-align: center;
    text-indent: 0;
    margin-bottom: 0.2em;
  }

  .doc-subtitle {
    font-size: 12pt;
    text-align: center;
    text-indent: 0;
    margin-bottom: 1.6em;
  }

  .doc-section {
    font-size: 12pt;
    font-weight: 700;
    text-align: left;
    text-indent: 0;
    margin: 1.6em 0 0.6em;
  }

  .print-footer {
    margin-top: 2.4em;
    padding-top: 0.6em;
    border-top: 1px solid #999;
    font-size: 9pt;
    color: #444;
    text-align: center;
    text-indent: 0;
  }
`;

/**
 * Abre uma janela dedicada com o conteudo ja formatado e dispara a
 * impressao. O usuario escolhe "Salvar como PDF" no dialogo do sistema.
 */
export function openPrintWindow(title: string, bodyHtml: string, subtitle?: string): void {
  const printWindow = window.open('', '_blank', 'width=900,height=1000');
  if (!printWindow) {
    alert('Permita pop-ups para exportar em PDF.');
    return;
  }

  const document2 = printWindow.document;
  document2.open();
  document2.write(`<!doctype html>
<html lang="pt-BR">
<head>
<meta charset="utf-8" />
<title>${escapeForPrint(title)}</title>
<style>${ABNT_PAGE_CSS}</style>
</head>
<body>
  <div class="doc-title">${escapeForPrint(title)}</div>
  ${subtitle ? `<div class="doc-subtitle">${escapeForPrint(subtitle)}</div>` : ''}
  ${bodyHtml}
  <div class="print-footer">
    Sistema de Ministrações Face a Face · Desenvolvido por Arnaldo Martins Hidalgo Junior · DevMenthors Unimar
  </div>
</body>
</html>`);
  document2.close();

  printWindow.focus();
  // Aguarda o layout antes de abrir o dialogo de impressao.
  setTimeout(() => {
    printWindow.print();
  }, 350);
}

function escapeForPrint(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

/** Exporta um roteiro HTML (já sanitizado pela API) em ABNT. */
export function printScript(title: string, subtitle: string, html: string): void {
  const body = html.trim() || '<p>Roteiro não preenchido.</p>';
  openPrintWindow(title, body, subtitle);
}
